import React, {useContext, useRef, useState} from "react";
import ConfirmationDialog from "../../containers/VirtualPortfolioManager/modals/ConfirmationDialog";

export const ConfirmationModalContext = React.createContext({});

const ConfirmationModalContextProvider = (props) => {
  const [modalData, setModalData] = useState({});
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const resolver = useRef();

  const handleShow = (message, confirmButtonText, rejectButtonText, title, customClasses) => {
    // Support both signatures: TODO: move all to use obj later
    //   confirm("msg", "Ja", "Nein", "Titel", {...customClasses})
    //   confirm({ message, confirmButtonText, rejectButtonText, title, variant, customClasses })
    const options = (message !== null && typeof message === "object")
      ? message
      : {message, confirmButtonText, rejectButtonText, title, customClasses};

    setModalData(options);
    setShowConfirmationModal(true);

    return new Promise(function (resolve) {
      resolver.current = resolve;
    });
  };

  const onClose = () => {
    setShowConfirmationModal(false);
  };

  const handleOk = () => {
    resolver.current && resolver.current(true);
    onClose();
  };

  const handleReject = () => {
    resolver.current && resolver.current(false);
    onClose();
  };

  const handleClose = () => {
    resolver.current && resolver.current(undefined);
    onClose();
  };

  return (
    <ConfirmationModalContext.Provider value={{confirm: handleShow, dismiss: handleClose}}>
      {props.children}

      <ConfirmationDialog
        message={modalData.message || "Sind Sie sicher?"}
        open={showConfirmationModal}
        onClose={handleReject}
        onCancel={handleClose}
        confirm={handleOk}
        confirmButtonText={modalData.confirmButtonText}
        rejectButtonText={modalData.rejectButtonText}
        title={modalData.title}
        variant={modalData.variant}
        customClasses={modalData.customClasses}
      />

    </ConfirmationModalContext.Provider>
  )
};

export const useConfirmationModalContext = () => useContext(ConfirmationModalContext);
export default ConfirmationModalContextProvider;